import { RootState } from "../store";

export const selectShowSpinner = (state: RootState) => { return ( state.spinner.requests > 0 ); };
export const selectTextSpinner = (state: RootState) => state.spinner.message;